import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

import {
  GNB_HEIGHT,
  CHAT_MENU_WIDTH,
  VIEWER_LEFT_LIST_WIDTH,
  VIEWER_LIST_HEADER_HEIGHT,
  VIEWER_LIST_TABS_HEIGHT,
  VIEWER_TITLE_BAR_HEIGHT,
  VIEWER_MOBILE_DIMENSIONS_BUTTON_HEIGHT
} from '../../constants';

const useStyles = makeStyles((theme) => ({
  'Chat-Menu-Viewer-root': {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      height: `100vh`,
      flexDirection: 'column'
    },
    '&.full-height': {
      height: 'calc(100vh - 64px - 49px)'
    }
  },
  'Viewer-File-Avatar': {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& .avatar': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colorSet.gray000,
      width: 42,
      height: 42,
      border: `1px solid ${colorSet.gray400}`,
      borderRadius: '8px',
      overflow: 'hidden',
      '& img': {
        width: '100%',
        height: '100%',
        borderRadius: '8px'
      }
    },
    '& .fileName': {
      display: 'flex',
      alignItems: 'center',
      color: colorSet.gray900,
      ...theme.typography.body2
    }
  },
  'Viewer-Header-root': {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: 49,
    minHeight: 49,
    padding: '6px 16px',
    borderBottom: `1px solid ${colorSet.gray200}`,
    [theme.breakpoints.down('md')]: {
      padding: '6px 16px'
    },
    '&.chat': {
      width: `calc(100% - ${CHAT_MENU_WIDTH}px)`,
      [theme.breakpoints.down('md')]: {
        width: '100%'
      }
    },
    '& .close': {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '& svg': {
        height: 24,
        width: 24
      }
    },
    '&.empty': {
      zIndex: -1,
      position: 'relative',
      visibility: 'hidden',
      width: '100%',
      height: 49,
      minHeight: 49
    },
    '& .mobile-header-icon-group': {
      display: 'flex',
      gap: '4px',
      '& button': {
        padding: 6
      }
    }
  },
  'Viewer-Content-Wrapper': {
    position: 'relative',
    display: 'flex',
    height: `calc(100vh - ${VIEWER_TITLE_BAR_HEIGHT}px)`,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      height: '100%'
    }
  },
  'Viewer-File-List-root': {
    position: 'fixed',
    left: 0,
    height: `calc(100% - ${VIEWER_TITLE_BAR_HEIGHT}px)`,
    width: '100%',
    maxWidth: VIEWER_LEFT_LIST_WIDTH,
    display: 'flex',
    flexDirection: 'column',
    borderRight: `1px solid ${colorSet.gray200}`,
    [theme.breakpoints.down('md')]: {
      position: 'inherit',
      left: 0,
      maxWidth: '100%',
      height: 64
    },
    [theme.breakpoints.down('xs')]: {
      height: 'unset',
      maxHeight: 64 + 52
    },
    '&.default': {
      height: `calc(100% - ${VIEWER_TITLE_BAR_HEIGHT}px)`,
      right: 0,
      [theme.breakpoints.down('md')]: {
        position: 'inherit',
        height: 64,
        left: 'unset',
        right: 'unset'
      },
      [theme.breakpoints.down('xs')]: {
        height: 'unset',
        maxHeight: 64 + 52
      }
    },

    '& .file-list-header': {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      maxWidth: VIEWER_LEFT_LIST_WIDTH,
      height: 60,
      borderBottom: `1px solid ${colorSet.gray200}`,
      padding: '22px 16px',
      '& .list-header-tab': {
        display: 'flex',
        gap: '16px',
        '& button': {
          color: colorSet.gray500,
          '&.selected-list': {
            color: colorSet.gray900
          }
        }
      },
      [theme.breakpoints.down('md')]: {
        minHeight: 64,
        height: 64,
        backgroundColor: colorSet.gray100,
        justifyContent: 'space-between',
        padding: '16px 16px',
        maxWidth: '100%'
      },
      '& .viewer-menu-button': {
        padding: 8
      },
      '& button': {
        padding: 6
      },
      '&.empty': {
        minHeight: 60,
        width: '100%',
        zIndex: -1,
        position: 'relative',
        [theme.breakpoints.down('md')]: {
          height: 64
        }
      }
    }
  },
  'Viewer-Content': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: `calc(100vw - ${VIEWER_LEFT_LIST_WIDTH + 1}px)`,
    width: `100%`,
    height: `calc(100vh - ${VIEWER_TITLE_BAR_HEIGHT}px)`,
    padding: 32,
    backgroundColor: '#FAF9FA',
    position: 'fixed',
    right: 0,
    [theme.breakpoints.down('md')]: {
      position: 'inherit',
      right: `unset`,
      overflow: 'scroll',
      maxWidth: '100%'
    },
    [theme.breakpoints.down('xs')]: {
      height: `calc(100% - ${
        VIEWER_TITLE_BAR_HEIGHT + VIEWER_MOBILE_DIMENSIONS_BUTTON_HEIGHT
      }px)`
    },
    '&.default': {
      maxWidth: `calc(100% - ${VIEWER_LEFT_LIST_WIDTH + 1}px)`,
      height: `calc(100% - ${VIEWER_TITLE_BAR_HEIGHT}px)`,
      right: 0,
      [theme.breakpoints.down('md')]: {
        right: `unset`,
        height: '100%',
        maxWidth: '100%'
      }
    },
    '&.tutorial-image': {
      backgroundColor: colorSet.gray000
    },
    '& .icon-button': {
      position: 'fixed',
      width: 44,
      height: 44,
      zIndex: 1,
      border: `1px solid ${colorSet.gray600}`,
      backgroundColor: colorSet.gray000,
      padding: 6,
      transition: '0.2s background-color ease-in-out',
      top: 'calc(100% / 2)',
      [theme.breakpoints.down('md')]: {
        width: 36,
        height: 36,
        boxShadow:
          '0px 2px 4px -1px rgba(0, 0, 0, 0.1), 0px 4px 5px rgba(0, 0, 0, 0.07), 0px 1px 10px rgba(0, 0, 0, 0.06)'
      },
      '&.Mui-disabled': {
        backgroundColor: colorSet.gray200,
        border: 'none',
        '& svg': {
          color: colorSet.gray600
        }
      },
      '& svg': {
        color: colorSet.gray900,
        width: 32,
        height: 32,
        [theme.breakpoints.down('md')]: {
          width: 24,
          height: 24
        }
      },
      '&.left': {
        left: 324,
        [theme.breakpoints.down('md')]: {
          left: 16
        }
      },
      '&.right': {
        right: 24,
        [theme.breakpoints.down('md')]: {
          right: 16
        },
        '&.default': {
          right: 24
        }
      }
    },
    '&.image-viewer': {
      '& img': {
        maxWidth: 800,
        width: '100%',
        height: '100%',
        objectFit: 'scale-down'
      }
    },

    '&.error-viewer': {
      flexDirection: 'column',
      '& img': {
        marginBottom: 16
      },
      '& .download': {
        backgroundColor: colorSet.gray000,
        maxWidth: 162
      }
    },

    '&.pdf-viewer': {
      overflow: 'scroll'
    }
  },
  'Viewer-Menu-Tabs-root': {
    width: '100%',
    '& .MuiTab-root': {
      minWidth: 'unset',
      height: 50,
      width: '100%',
      maxWidth: 'calc(100% / 3)',
      '& .MuiTab-wrapper': {
        ...theme.typography.body2,
        color: colorSet.gray500,
        fontWeight: 500,
        opacity: 1,
        '&.selected': {
          fontWeight: 500,
          color: colorSet.gray900,
          backgroundColor: colorSet.gray000
        }
      },
      '&.double': {
        maxWidth: 'calc(100% / 2)'
      }
    },

    '& .MuiTabs-indicator': {
      backgroundColor: colorSet.gray900
    }
  },
  'Viewer-Right-Drawer-root': {
    height: '100%',
    '& .MuiDrawer-paper': {
      width: '100%'
    },
    '& .Viewer-Right-Drawer-Header': {
      width: '100%',
      height: 64,
      padding: '12px 16px 0px',
      borderBottom: `1px solid ${colorSet.gray200}`,
      display: 'flex',
      flexDirection: 'column',
      '& .icon-group': {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '10px',
        '& .top-cta': {
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          width: 'fit-content',
          '& > svg': {
            width: 20,
            height: 20,
            marginRight: 4,
            color: colorSet.primary500,
            [theme.breakpoints.down('md')]: {
              width: 24,
              height: 24,
              marginRight: 4,
              color: colorSet.gray900
            }
          }
        }
      },
      [theme.breakpoints.down('md')]: {
        height: 'unset'
      }
    }
  },
  'Viewer-File-List-Items-root': {
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100vh - ${
      VIEWER_TITLE_BAR_HEIGHT +
      VIEWER_LIST_HEADER_HEIGHT +
      VIEWER_LIST_TABS_HEIGHT +
      GNB_HEIGHT
    }px)`,
    overflow: 'scroll',
    [theme.breakpoints.down('md')]: {
      height: '100%'
    },
    '&.default': {
      height: `calc(100vh - ${
        VIEWER_TITLE_BAR_HEIGHT + VIEWER_LIST_HEADER_HEIGHT
      }px)`
    },
    '&.empty': {
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  'Viewer-File-List-Item-root': {
    display: 'flex',
    position: 'relative',
    padding: '12px 10px',
    borderBottom: `1px solid ${colorSet.gray200}`,
    '& .annotation-notice-pin': {
      position: 'absolute',
      top: '5px',
      left: '46px',
      width: 12,
      height: 15,
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        filter:
          'drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.06)) drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.07)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1))'
      }
    },
    '&.actived': {
      backgroundColor: colorSet.gray200
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: colorSet.gray100
    },
    '& .thumbnail': {
      width: 42,
      height: 42,
      border: `1px solid ${colorSet.gray400}`,
      borderRadius: '8px',
      marginRight: 8,
      overflow: 'hidden',
      zIndex: 1,
      backgroundColor: colorSet.gray000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '& .fileName': {
      display: 'flex',
      alignItems: 'center'
    }
  },
  'Viewer-Download-Snackbar': {
    position: 'fixed',
    bottom: 24,
    left: 24,
    backgroundColor: colorSet.gray900,
    padding: '7px 20px',
    borderRadius: 8,
    zIndex: 9999,
    maxWidth: 343,
    width: '100%',
    height: 50,
    [theme.breakpoints.down('md')]: {
      bottom: 24,
      left: 16
    },
    '& .content': {
      display: 'flex',
      alignItems: 'center',
      ...theme.typography.subtitle2,
      color: colorSet.gray000,
      width: 207,
      height: 36,
      wordBreak: 'break-all'
    },
    '& .close': {
      cursor: 'pointer',
      right: 0,
      top: 8,
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 84,
      height: 32,
      '& span': {
        ...theme.typography.subtitle2,
        color: colorSet.errorBase
      },
      '& svg': {
        color: colorSet.gray000,
        width: 20,
        height: 20,
        marginLeft: 20
      }
    }
  },
  'DrawingFile-Viewer-error': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  }
}));

export default useStyles;
